export const Method_Get_Session_Reports_List = 'lab-report/';
export const Method_Get_Usage_Reports_List = 'lab-report/usage/';

